import { defineMessages } from 'react-intl';
import type { LocalePerProduct } from 'contracts';

const agreementCheckbox: LocalePerProduct = {
  livejasmin: defineMessages({
    label: {
      id: 'pages.signup.registration.components.agreementCheckbox.livejasmin.label',
      defaultMessage:
        'I accept the <a1>Services Agreement</a1>, <a2>Sensitive Data</a2> and <a3>Cookie</a3> policies for Models/Studios.',
    },
  }),
  oranum: defineMessages({
    label: {
      id: 'pages.signup.registration.components.agreementCheckbox.oranum.label',
      defaultMessage:
        'I accept the <a1>Services Agreement</a1>, <a2>Sensitive Data</a2> and <a3>Cookie</a3> policies for Broadcasters/Agencies.',
    },
  }),
};

export default {
  pages: {
    signup: {
      registration: {
        components: {
          agreementCheckbox: {
            ...defineMessages({
              hint: {
                id: 'pages.signup.registration.components.agreementCheckbox.hint',
                defaultMessage: 'You need to accept the Services Agreement before you continue.',
              },
            }),
            ...agreementCheckbox,
          },
        },
      },
    },
  },
};
